import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import Badge from "@mui/material/Badge";
import Box from "@mui/material/Box";
import Fab from "@mui/material/Fab";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import moment from "moment";
import "moment/locale/id";
import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-scroll";
import Swal from "sweetalert2";
import DebtPayment from "../../components/DebtPayment/DebtPayment";
import ListBarang from "../../components/ListBarang/ListBarang";
import ListPesan from "../../components/ListPesan/ListPesan";
import ModalBayar from "../../components/ModalBayar/ModalBayar";
import ModalDetailBarang from "../../components/ModalDetailBarang/ModalDetailBarang";
import ModalDiskon from "../../components/ModalDiskon/ModalDiskon";
import ModalKonfirmasiBayar from "../../components/ModalKonfirmasiBayar/ModalKonfirmasiBayar";
import ModalPopup from "../../components/ModalPopup/ModalPopup";
import ModalStok from "../../components/ModalStok/ModalStok";
import Spinner from "../../components/Spinner/Spinner";
import TokoTidakAktif from "../../components/TokoTidakAktif/TokoTidakAktif";
import { IOptions, ParamsGetItem, ParamsGetKategori } from "../../constants/types";
import { useAuth } from "../../context/authContext";
import { DebtProvider } from "../../context/DebtContext";
import { useTransaksi } from "../../context/transaksiContext";
import useItem from "../../services/queries/useItem";
import useKategori from "../../services/queries/useKategori";
import useTimeAlt from "../../services/queries/useTimeAlt";
import useUkm from "../../services/queries/useUkm";
import useUser from "../../services/queries/useUser";
import { getLocalUkmId, setLocalUkmId } from "../../utils/handleChangeUkmId";
import scrollToHash from "../../utils/scrollToHash";

moment.locales();
moment.locale("id");

interface ITransaksi {}

const Transaksi = (props: ITransaksi) => {
    const { ukmIdUser, isAuthenticated } = useAuth();
    const { data: user, status: statusUser } = useUser();
    const theme = useTheme();
    const isPhoneScreen = useMediaQuery(theme.breakpoints.down("md"));
    const isTabletScreen = useMediaQuery(theme.breakpoints.between("md", "lg"));
    const isLaptopScreen = useMediaQuery(theme.breakpoints.up("lg"));

    const [diskon, setDiskon] = useState<number>();
    const [persentaseDiskon, setPersentaseDiskon] = useState<number | null>();
    const [pajak, setPajak] = useState<number>();
    const [persentasePajak, setPersentasePajak] = useState<number | null>();
    const [service, setService] = useState<number>();
    const [persentaseService, setPersentaseService] = useState<number | null>();
    const [tagihan, setTagihan] = useState<number>();
    const [uangDibayar, setUangDibayar] = useState<number>();
    const [kembalian, setKembalian] = useState<number>();
    const [sales, setSales] = useState<IOptions | null>(null);

    const initialParamsItem = {
        ukmId: undefined,
        size: 1500,
        page: 1,
        isShow: 0,
        search: "",
        kategori: "",
    };

    const [paramsItem, setParamsItem] =
        useState<ParamsGetItem>(initialParamsItem);
    const { refetch: refetchItem } = useItem(paramsItem);
    const initialParamsKategori = {
        ukmId: undefined,
        size: 500,
        page: 1,
        search: "",
    };
    const [paramsKategori, setParamsKategori] = useState<ParamsGetKategori>(
        initialParamsKategori,
    );
    const { refetch: refetchKategori } = useKategori(paramsKategori);
    const initialParamsUkm = {
        size: 500,
        page: 1,
        search: "",
    };
    const { data: ukm, status: statusUkm } = useUkm(initialParamsUkm);
    const { data: time, status: statusTime } = useTimeAlt();

    const [isCardView, setIsCardView] = useState(false);
    const { cart, paymentMode } = useTransaksi();

    const handlingRincianPembayaran = (
        persentaseDiskon: number | null,
        diskon: number | null,
        persentasePajak: number | null,
        pajak: number | null,
        serviceCustom: number | null,
        serviceCustomPersen: number | null,
        tagihan: number,
        uangYangDibayar: number,
        kembalian: number,
        sales: IOptions | null,
    ) => {
        if (diskon && diskon > 0) {
            setDiskon(diskon);
        } else {
            setDiskon(0);
        }
        if (persentaseDiskon !== null) {
            setPersentaseDiskon(persentaseDiskon);
        }
        if (pajak && pajak > 0) {
            setPajak(pajak);
        } else {
            setPajak(0);
        }
        if (persentasePajak !== null) {
            setPersentasePajak(persentasePajak);
        }
        if (serviceCustom && serviceCustom > 0) {
            setService(serviceCustom);
        } else {
            setService(0);
        }
        if (serviceCustomPersen !== null) {
            setPersentaseService(persentaseService);
        }
        setTagihan(tagihan);
        setUangDibayar(uangYangDibayar);
        setKembalian(kembalian);
        setSales(sales);
    };

    const [keteranganBeli, setKeteranganBeli] = useState<string>("");

    const resetKeteranganBeli = useCallback(() => {
        setKeteranganBeli("");
    }, []);
    
    const handleCardView = useCallback(() => setIsCardView(true), []);
    const handleListView = useCallback(() => setIsCardView(false), []);

    const [isOpenPopup, setIsOpenPopup] = useState(false);

    const openPopup = () => setIsOpenPopup(true);
    const closePopup = () => setIsOpenPopup(false);

    const ukmId = React.useMemo(() => {
        if (user?.userId) {
            return getLocalUkmId(user?.userId);
        }
        return null;
    }, [user?.userId]);

    const ukmData = React.useMemo(() => {
        if (ukmId) {
            return ukm?.content.find((li) => li.id === ukmId);
        }
        return ukm?.content[0];
    }, [ukm?.content, ukmId]);

    // useEffect(() => {        
    //     if (isAuthenticated && ukmData?.trialFlag10 === 1) {
    //         openPopup();
    //     } else {
    //         closePopup();
    //     }
    // }, [ukmData?.trialFlag10, isAuthenticated]);

    useEffect(() => {
        const popupShown = localStorage.getItem('popupShownAfterLogin');
        
        if (isAuthenticated && ukmData?.trialFlag10 === 1 && ukmData?.isTrial === 1 && !popupShown) {
            openPopup();
            localStorage.setItem('popupShownAfterLogin', 'true');
        } else {
            closePopup();
        }
    }, [ukmData?.trialFlag10, isAuthenticated, ukmData?.isTrial]);

    useEffect(() => {
        if (ukmIdUser) {
            setParamsItem((prev) => ({
                ...prev,
                ukmId: ukmIdUser && ukmIdUser[0],
            }));
            setParamsKategori((prev) => ({
                ...prev,
                ukmId: ukmIdUser && ukmIdUser[0],
            }));
        }
    }, [ukmIdUser]);

    useEffect(() => {
        scrollToHash();
    }, []);

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const queryUkmId = urlParams.get("redirect");

    useEffect(() => {
        if (queryUkmId) {
            user?.userId && setLocalUkmId(user?.userId, Number(queryUkmId));
        }
    }, [queryUkmId, user?.userId]);

    useEffect(() => {
        if (queryUkmId && user && ukm && Number(queryUkmId) !== ukmId) {
            // window.location.reload();
            window.location.replace("/transaksi");
        } else if (queryUkmId && user && ukm && Number(queryUkmId) === ukmId) {
            window.location.replace("/transaksi");
        }
    }, [queryUkmId, ukm, ukmId, user]);

    const isSudahJatuhTempo = moment(time?.dateTime).isAfter(
        ukmData?.pembayaranBerikutnya,
    );

    const [isError, setIsError] = useState(false);

    const handleIsError = () => setIsError(true);

    if (
        statusUser === "loading" ||
        statusUkm === "loading" ||
        statusTime === "loading" ||
        (queryUkmId && Number(queryUkmId) !== ukmId)
    ) {
        return (
            <Box
                position="relative"
                height={isLaptopScreen ? "100vh" : "calc(100vh - 56px)"}
            >
                <Spinner />
            </Box>
        );
    }

    if (isError) {
        // return <ErrorFetchView />;
        Swal.fire({
            title: "Maaf, kami tidak dapat memproses permintaan anda",
            text: `Silahkan coba lagi dengan memuat ulang halaman`,
            position: "top-end",
            showConfirmButton: false,
            icon: "error",
            toast: true,
            width: 600,
            timer: 3000,
            timerProgressBar: true,
            // confirmButtonColor: "#45A779",
            // showCloseButton: true,
            customClass: {
                container: "my-swal",
            },
        });
    }

    if (user?.aksesTransaksi === 0 || user?.aksesTransaksi === null) {
        return <TokoTidakAktif label="Anda tidak memiliki akses halaman ini" />;
    }

    if (
        ukmData &&
        (ukmData?.isActive === 0 ||
            ukmData?.isActive === null ||
            ukmData?.lewatTempoPro === 1 ||
            isSudahJatuhTempo)
    ) {
        return <TokoTidakAktif namaToko={ukmData.namaToko} />;
    }

    return (
        <Box bgcolor="#ffffff">
            <Grid container minHeight="100dvh">

                {paymentMode === "normal" && (
                    <>
                        <ModalBayar handlingRincianPembayaran={handlingRincianPembayaran} />
                        <ModalKonfirmasiBayar
                            kasir={String(user?.namaLengkap)}
                            sales={sales}
                            diskon={diskon}
                            persentaseDiskon={persentaseDiskon}
                            pajak={pajak}
                            persentasePajak={persentasePajak}
                            serviceCustom={service}
                            serviceCustomPersen={persentaseService}
                            totalTagihan={Number(tagihan)}
                            uangDibayar={Number(uangDibayar)}
                            kembalian={Number(kembalian)}
                            refetch={refetchItem}
                            keteranganBeli={keteranganBeli}
                            resetKeteranganBeli={resetKeteranganBeli}
                        />
                    </>
                )}
                
                {paymentMode === "debt" && (
                    <DebtProvider>
                        <DebtPayment />
                    </DebtProvider>
                )}

                {!paymentMode && (
                    <>
                        <Grid
                            item
                            xs={12}
                            sm={12}
                            md={isTabletScreen ? 5.5 : isCardView ? 7 : 6}
                            sx={{
                                overflowY: "scroll",
                            }}
                        >
                            <ListBarang
                                isCardView={isCardView}
                                cardView={handleCardView}
                                listView={handleListView}
                                handleIsError={handleIsError}
                            />
                        </Grid>
                        <Grid
                            id="barangPesanan"
                            item
                            xs={12}
                            sm={12}
                            // md={isTabletScreen ? 6.5 : isCardView ? 5 : 6}
                            md={isTabletScreen ? 6.5 : isCardView ? 6 : 6}
                            sx={{
                                borderLeft: isPhoneScreen
                                    ? undefined
                                    : "1px solid rgba(0, 0, 0, 0.12)",
                                borderRight: isPhoneScreen
                                    ? undefined
                                    : "1px solid rgba(0, 0, 0, 0.12)",
                            }}
                        >
                            <ListPesan handleIsError={handleIsError} />
                        </Grid>
                    </>
                )}
            </Grid>
            <Link
                activeClass="active"
                to="barangPesanan"
                spy={true}
                smooth={true}
                duration={500}
            >
                <Box
                    sx={{ display: { xs: "block", md: "none" } }}
                    position="fixed"
                    bottom={70}
                    right={16}
                >
                    <Badge
                        badgeContent={cart.length}
                        color="secondary"
                        overlap="circular"
                    >
                        <Fab color="primary" aria-label="add">
                            <ShoppingCartIcon />
                        </Fab>
                    </Badge>
                </Box>
            </Link>
            <ModalStok
                refetchItem={refetchItem}
                refetchKategori={refetchKategori}
            />
            <ModalDetailBarang />
            <ModalDiskon />
            <ModalPopup 
                dataUkm={{ 
                    id: ukmData?.id || 0,
                    nama: ukmData?.namaToko || '',
                    trialFlag10: ukmData?.trialFlag10 || 0,
                    trialTempo: ukmData?.trialTempo || null,
                }}
                open={isOpenPopup} 
                onClose={closePopup} 
            />
        </Box>
    );
};

export default Transaksi;
